import { render, staticRenderFns } from "./CompArticleImage.vue?vue&type=template&id=0ca46692&scoped=true"
import script from "./CompArticleImage.vue?vue&type=script&setup=true&lang=js"
export * from "./CompArticleImage.vue?vue&type=script&setup=true&lang=js"
import style0 from "./CompArticleImage.vue?vue&type=style&index=0&id=0ca46692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ca46692",
  null
  
)

export default component.exports